import 'babel-polyfill';

const elements = {
  link: [...document.querySelectorAll('.js-share-link')],
};

function popupHandler(e) {
  const url = this.getAttribute('href');
  const height = 500;
  const width = 500;
  const left = Math.floor(((window.screen.availWidth || 1024) - width) / 2);
  const top = Math.floor(((window.screen.availHeight || 700) - height) / 2);
  const popup = window.open(url, 'social', `width=${width},height=${height},left=${left},top=${top},location=0,menubar=0,toolbar=0,status=0,scrollbars=1,resizable=1`);

  if (popup) {
    e.preventDefault();
    popup.focus();
    e.returnValue = false;
  }

  return !!popup;
}

function init() {
  if (elements.link.length > 0) {
    elements.link.forEach((el) => {
      el.addEventListener('click', popupHandler);
    });
  }
}

export default init;



// WEBPACK FOOTER //
// ./src/components/components/searches/share/mando-ui.share.js